// "Wed, Aug 19, evening" — sellers need the day and rough time of day, not a
// timestamp. Shared by the seller dashboard order card and the order detail
// page so the two surfaces can't drift apart on how a pickup is described.
export function formatScheduledFor(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const weekday = d.toLocaleDateString(undefined, { weekday: "short" });
  const date = d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const hour = d.getHours();
  const window = hour < 12 ? "morning" : hour < 17 ? "afternoon" : "evening";
  return `${weekday}, ${date}, ${window}`;
}

export function formatOrderStatus(status: string | null | undefined): string {
  const normalized = String(status || "").trim().toLowerCase();

  if (normalized === "paid") return "Paid";
  if (normalized === "pending") return "Pending payment";
  if (normalized === "cancel_requested") return "Cancellation requested";
  if (normalized === "preparing") return "Preparing";
  if (normalized === "ready_for_pickup") return "Ready for pickup";
  if (normalized === "picked_up") return "Picked up";
  if (normalized === "out_for_delivery") return "Out for delivery";
  if (normalized === "delivered") return "Delivered";
  if (normalized === "cancelled") return "Cancelled";
  if (normalized === "refunded") return "Refunded";

  return normalized
    ? normalized
        .split("_")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ")
    : "Unknown";
}
